<script>
import { mapActions } from "vuex";

export default {
  data: function() {
    return {
      hasLabMenu: false
    };
  },

  methods: {
    ...mapActions("auth", ["signOut"]),

    handleSignOut() {
      document
        .querySelector("ion-menu-controller")
        .toggle()
        .then(() => {
          return this.signOut();
        })
        .then(() => {
          this.$router.push("/").catch(e => e);
        });
    },

    navigate(name) {
      document.querySelector("ion-menu-controller").toggle();
      this.$router.push({ name }).catch(e => e);
    },

    showLabMenu() {
      this.hasLabMenu = true;
    }
  }
};
</script>
